/* eslint-disable prefer-template */
/* eslint-disable default-param-last */ import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
    data: [],
    isLoading: false,
    responseTime: 0,
    isError: false,
    msgError: '',
  };
  export const headcountReprimandTrendCSVReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case actionType.HEADCOUNT_REPRIMANDTREND_CSV + '_LOADING':
        return {
          ...state,
          isLoading: true,
        };
      case actionType.HEADCOUNT_REPRIMANDTREND_CSV + '_RESULT':
        return {
          ...state,
          data: action.result.data,
          responseTime: action.result.responseTime,
          isLoading: false,
          isError: false,
          msgError: '',
        };
      case actionType.HEADCOUNT_REPRIMANDTREND_CSV + '_FAILED':
        return {
          ...state,
          isLoading: false,
          isError: true,
          msgError: action.err,
        };
      default:
        return state;
    }
  };
  